import moment, { Moment } from "moment"
import czHolidays from "../../lib/cz-holidays-2021-2030.json"

export interface CourseDates {
  lessonDates: Moment[]
  lastLessonDate: Moment
  skippedDates: Moment[]
}

export const getCourseDates = ({ courseFirstDay, lessonCount }: { courseFirstDay?: string | Date; lessonCount?: number }): CourseDates | null => {
  if (!courseFirstDay || !lessonCount || !courseFirstDay || !lessonCount) return null

  const holidaySet = new Set(czHolidays)
  const isCzechHoliday = (date: moment.Moment): boolean => holidaySet.has(date.format("YYYY-MM-DD"))

  const lessonDates: Moment[] = []
  const skippedDates: Moment[] = []

  let currentDate = moment(courseFirstDay)
  let addedLessons = 0
  let safetyCounter = 0
  const maxWeeksToScan = 100

  while (addedLessons < lessonCount && safetyCounter < maxWeeksToScan) {
    if (isCzechHoliday(currentDate)) {
      skippedDates.push(currentDate.clone())
    } else {
      lessonDates.push(currentDate.clone())
      addedLessons++
    }

    currentDate = currentDate.clone().add(1, "week")
    safetyCounter++
  }

  if (addedLessons < lessonCount) {
    throw new Error("Unable to generate the full schedule within 100 weeks. Check input values.")
  }

  return {
    lessonDates,
    lastLessonDate: lessonDates[lessonDates.length - 1],
    skippedDates
  }
}
